var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableDropDownOpenButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.03931,
    cy: 8.6179,
    r: 8,
    fill: "#00B6CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0393 7.52791C4.0393 7.29575 4.12876 7.06358 4.30554 6.88467C4.66124 6.52897 5.23632 6.52897 5.58989 6.88467L8.12876 9.42354L10.6676 6.8868C11.0233 6.5311 11.5984 6.5311 11.952 6.8868C12.3077 7.2425 12.3077 7.81758 11.952 8.17115L8.772 11.3511C8.4163 11.7068 7.84122 11.7068 7.48765 11.3511L4.30554 8.17115C4.12876 7.99436 4.0393 7.76007 4.0393 7.52791Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableDropDownOpenButton);
export default __webpack_public_path__ + "static/media/TableDropDownOpenButton.78b69436be8a2592dc81c9e01a73a861.svg";
export { ForwardRef as ReactComponent };